<div class="hs-box"
     (click)="toggleOverlay(); $event.stopPropagation()"
     [title]="'Horizontal Skew — ' + this.displayLabel + ' term structure (ATM IV short / long)'">
    <dx-load-indicator *ngIf="this.loading" width="8" height="8" [visible]="true"></dx-load-indicator>
    <span *ngIf="!this.loading" class="hs-value">{{ this.displayRatio }}</span>
</div>

<div class="hs-overlay" *ngIf="this.overlayVisible" [ngStyle]="this.overlayStyle" (click)="$event.stopPropagation()">

    <div class="hs-header">
        <span class="hs-title">Horizontal Skew — {{ this.displayLabel }} term structure</span>
        <button type="button" class="hs-chart-btn"
                title="Open term-structure chart"
                (click)="openChart(); $event.stopPropagation()">
            <i class="fas fa-chart-line"></i>
        </button>
    </div>

    <div class="hs-reading">
        <!-- loading = change in flight / IVs warming -> spinner; N/A only when SETTLED
             (loading=false, ratio=null: chain failure / no listed options). -->
        <dx-load-indicator *ngIf="this.loading" width="16" height="16" [visible]="true"></dx-load-indicator>
        <span *ngIf="!this.loading" class="hs-ratio" [ngClass]="colorClass()">{{ this.displayRatio }}</span>
        <span class="hs-band-name" *ngIf="this.band">{{ this.band }}</span>
    </div>

    <div class="hs-controls">
        <div class="hs-leg">
            <span class="hs-leg-cap">Short</span>
            <dx-number-box
                [value]="this.short"
                [min]="1" [step]="1"
                [showSpinButtons]="true"
                [width]="90"
                (onValueChanged)="onShortChanged($event)">
            </dx-number-box>
            <!-- The listed expiration this day count resolved to — several counts map
                 to one date, so a click that doesn't move it is visibly a no-op. -->
            <span class="hs-leg-exp" title="Resolved expiration">{{ this.shortLegLabel || '—' }}</span>
        </div>
        <span class="hs-slash">/</span>
        <div class="hs-leg">
            <span class="hs-leg-cap">Long</span>
            <dx-number-box
                [value]="this.long"
                [min]="1" [step]="1"
                [showSpinButtons]="true"
                [width]="90"
                (onValueChanged)="onLongChanged($event)">
            </dx-number-box>
            <span class="hs-leg-exp" title="Resolved expiration">{{ this.longLegLabel || '—' }}</span>
        </div>
    </div>

    <div class="hs-basis">
        <dx-radio-group
            [items]="this.basisItems"
            displayExpr="text" valueExpr="value"
            layout="horizontal"
            [value]="this.basis"
            (onValueChanged)="onBasisChanged($event)">
        </dx-radio-group>
    </div>

    <div class="hs-cheatsheet">
        <div class="hs-cs-row" *ngFor="let b of this.bands" [class.active]="isBandActive(b.key)">
            <span class="hs-cs-label">{{ b.label }}</span>
            <span class="hs-cs-meaning">{{ b.meaning }}</span>
        </div>
    </div>

</div>

<!-- Standalone term-structure chart, opened by the overlay's chart button (reads this surface's basis). -->
<ets-horizontal-skew-chart-popup></ets-horizontal-skew-chart-popup>
